try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import { CtaBlock } from '@design-system/cta-block';
import { ExtendableImage } from '@design-system/extendable-image';
import { HeadingBlock } from '@design-system/heading-block';
import classNames from 'classnames';
import { forwardRef } from 'react';

const AssetItem = forwardRef(({ className, headingBlock, image, align = 'start', ctaBlock, mediaVariant = 'rounded', tag: Tag = 'div', isHorizontal, }, ref) => {
    const headingBlockProps = Object.assign(Object.assign({}, headingBlock), { align });
    return (jsxs(Tag, Object.assign({ ref: ref, className: classNames('cds-asset-item', className, {
            [`cds-asset-item--align-${align}`]: align,
            'cds-asset-item--horizontal': isHorizontal,
        }), "data-testid": "cds-asset-item" }, { children: [jsxs("div", Object.assign({ className: classNames('cds-asset-item__content', {
                    'cds-asset-item__content--horizontal': isHorizontal,
                }) }, { children: [jsxs("div", Object.assign({ className: "cds-asset-item__content-inner" }, { children: [jsx(HeadingBlock, Object.assign({}, headingBlockProps)), ctaBlock && jsx(CtaBlock, Object.assign({ align: align }, ctaBlock))] })), jsx("div", {})] })), image && (jsx("div", Object.assign({ className: classNames('cds-asset-item__media', `cds-asset-item__media--${mediaVariant}`, {
                    'cds-asset-item__media--horizontal': isHorizontal,
                }) }, { children: jsx(ExtendableImage, Object.assign({}, image, { className: "cds-asset-item__media-image" })) })))] })));
});

export { AssetItem };
